module.exports = __webpack_public_path__ + "static/media/cococad.dc8da354.png";